<template>
    <transition
        enter-from-class="-translate-x-10 opacity-0"
        enter-active-class="transition duration-150 ease-in-out transform"
        enter-to-class="translate-x-0 opacity-100"
        leave-from-class="translate-x-0 opacity-100"
        leave-active-class="transition duration-150 ease-in-out transform"
        leave-to-class="-translate-x-10 opacity-0"
    >
        <nav v-if="menuVisible" class="h-full lg:sticky top-0 flex w-full lg:w-[226px] absolute flex-col border-r border-stone-400 dark:bg-slate-900 dark:border-gray-700 bg-stone-300 z-50">
            <div class="flex justify-between p-2 space-x-4">
                <toggle-dark-mode />

                <div class="w-full flex">
                    <div class="absolute px-3 py-4 left-0 right-0 ml-auto mr-auto bg-blue-600 rounded-lg top-16 shadow-xl text-white text-center max-w-fit animate-bounce-less hover:animate-pause" v-if="!userGuide.modules">
                        <div class="absolute -top-2 left-0 right-0 ml-auto mr-auto border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-blue-600 w-0 h-0"></div>
                        <div class="flex flex-col space-y-2">
                            <span>Clique aqui para mudar de módulo.</span>
                            <button class="bg-blue-900 px-1 py-2 rounded-md hover:bg-blue-500 transition-colors duration-150 ease-out" @click="userGuideModule">OK</button>
                        </div>
                    </div>

                <button
                    v-if="isInterno"
                    class="flex-1 py-1 text-xs rounded-full bg-stone-400 dark:bg-slate-800 text-stone-600 dark:text-slate-200 hover:bg-stone-500 hover:text-stone-300 dark:hover:bg-slate-600 dark:hover:text-slate-100 transition-all ease-in-out duration-200 capitalize"
                    @click="openModuleSelector"
                >
                    <font-awesome-icon icon="bookmark" /> {{ module }}
                </button>
                </div>
                <button
                    class="tailx-btn-simple btn-simple-stone"
                    @click="store.dispatch('setMenuVisible')"
                >
                    <font-awesome-icon icon="arrow-left" />
                </button>
            </div>

            <!-- logo -->
            <div class="flex flex-col items-center justify-center py-2 space-y-2 shadow-md border-1 border-gray-50">
                <Logo
                    :light="`/storage/cadempresas/${$page.props.auth.user.cadempresa_id}/logo.png`"
                    :dark="`/storage/cadempresas/${$page.props.auth.user.cadempresa_id}/logo_light.png`"
                />
            </div>

            <!-- avatar -->
            <div class="flex items-center justify-start px-2 py-3 mb-2 text-gray-800 shadow-md border-1 dark:text-gray-100 border-gray-50">
                <font-awesome-icon icon="circle-user" class="w-14 h-14" />
                <Link
                    :href="
                        $page.props.auth.user.is_interno == 1
                            ? route('users.edit', { id: $page.props.auth.user.id, })
                            : route('usuarios_externos.edit', { id: $page.props.auth.user.id, })
                    "
                    class="text-xl text-lower ml-2"
                >
                    {{ firstName($page.props.auth.user.name) }}
                </Link>
            </div>
            <div class="relative w-full overflow-y-auto">
                <!-- menu -->
                <ul class="w-full">
                    <template v-for="item in cMenu" :key="item">
                        <CustomNavLink :item="item" :selected="selected" />
                    </template>
                </ul>
            </div>
            <div class="sticky bottom-0 flex justify-center w-full py-2 mt-auto">
                <button @click="openAlertModal" class="space-x-2 text-gray-800 transition-colors duration-150 dark:text-gray-100 dark:hover:hover:text-blue-400 hover:text-blue-600">
                    <font-awesome-icon icon="right-from-bracket" />
                    <span>Logout</span>
                </button>
            </div>
        </nav>
    </transition>
    <modal-alert
        :open="alertModal"
        @open="openAlertModal"
        :content="{
            title: 'Você deseja sair?',
            message: 'você será desconectado do sistema.',
        }"
        :actions="{
            confirmButton: true,
            confirmButtonText: 'Sair',
            confirmAction: confirmLogout,
        }"
        :time="5000"
        :options="{
            cancelButtonColor: 'bg-slate-600',
            confirmButtonColor: 'bg-red-600'
        }"
        :icon="'warning'"
    ></modal-alert>
    <ModuleSelector
        :open="moduleModal"
        ref="moduleRef"
        @open="openModuleSelector"
        @setModule="changeModule"
    ></ModuleSelector>
</template>

<script setup>
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import { Link, usePage } from "@inertiajs/vue3";
import toggleDarkMode from "@/Components/Custom/Buttons/toggleDarkMode.vue";
import Logo from "@/Components/Custom/Logo/Logo.vue";
import { firstName, lastName } from "@/src/functions.ts";
import { router } from "@inertiajs/vue3";
import ModuleSelector from "@/Components/ModuleSelector.vue";
import ModalAlert from "@/Components/Custom/Alerts/Modal.vue";
import CustomNavLink from "./CustomNavLink.vue";
const store = useStore();
const page = usePage();

const nomeTabela = computed(() =>  page.props.tableName)
const userGuide = computed(() => store.state.userGuide)
const moduleRef = ref(null);
const menuVisible = computed(() => store.state.menuVisible);
const selected = computed(
    () =>
        props.menu.filter((item) => {
            if (item.route === "crud.index") {
                return item?.params?.tabela === nomeTabela.value;
            }

            return item.route == route().current();
        })[0]
);
const isInterno = computed(() => {
    return page.props?.auth?.user?.is_interno == "1";
});

const props = defineProps({
    menu: {
        type: [Array, Object],
        default: () => [],
    },
});

const isDark = ref(localStorage.getItem("theme") == "dark");

const module = computed({
    get() {
        return store.state.module ?? "protocolos";
    },
    set(val) {
        store.dispatch("setModule", val);
    },
});

function changeModule(value) {
    module.value = value;
    openModuleSelector();
}

const moduleModal = ref(false);

const cMenu = computed(() => {
    return props.menu.filter((item) => {
        if (module.value !== null) {
            return module.value === item.module;
        }

        return true;
    });
});

function openModuleSelector() {
    moduleModal.value = !moduleModal.value;
}

const alertModal = ref(false);

function openAlertModal() {
    alertModal.value = !alertModal.value;
}

function confirmLogout() {
    router.post(route("logout"));
}

function userGuideModule(){

    store.dispatch("setUserGuide", {key:'modules', value:true})
}

onMounted(() => {
    let actualPageModule = page.props.module;
    let names = moduleRef.value.modulos.map(({ name }) => name);

    if (names.includes(actualPageModule) && module.value !== actualPageModule) {
        module.value = actualPageModule;
    } else if (
        module.value !== "protocolos" &&
        actualPageModule === "ordemdeservico"
    ) {
        module.value = "protocolos";
    }
});
</script>

<style></style>
